<section class="document-emailer">
  <h6 class="document-emailer__heading">Email documents</h6>
  <p class="document-emailer__intro small mb-3">Send selected documents to the recipient by email.</p>

  <form [formGroup]="form" (ngSubmit)="onSubmit()" novalidate>
    <div class="row form-group document-emailer__row mb-2">
      <label class="col-sm-4 col-md-3 col-lg-3 col-form-label col-form-label-sm document-emailer__label" for="doc-email-name">Recipient name</label>
      <div class="col-sm-8 col-md-6 col-lg-5">
        <input
          type="text"
          class="form-control form-control-sm"
          id="doc-email-name"
          formControlName="name"
          autocomplete="name"
          placeholder="Name"
        />
      </div>
    </div>

    <div class="row form-group document-emailer__row mb-3">
      <label class="col-sm-4 col-md-3 col-lg-3 col-form-label col-form-label-sm document-emailer__label" for="doc-email-address">Recipient email</label>
      <div class="col-sm-8 col-md-6 col-lg-5">
        <input
          type="email"
          class="form-control form-control-sm"
          id="doc-email-address"
          formControlName="email"
          autocomplete="email"
          placeholder="email@example.com"
        />
      </div>
    </div>

    <div class="document-emailer__docs" *ngIf="documents.length">
      <span class="document-emailer__docs-title">Include documents</span>
      <div formArrayName="documents" class="document-emailer__check-list">
        <div
          *ngFor="let document of documents; let i = index"
          class="custom-control custom-checkbox document-emailer__check"
        >
          <input
            type="checkbox"
            class="custom-control-input"
            [id]="'doc-email-' + i"
            [formControlName]="i"
          />
          <label class="custom-control-label" [for]="'doc-email-' + i">{{ document.title }}</label>
        </div>
      </div>
    </div>

    <p *ngIf="!documents.length" class="document-emailer__empty small">No documents available to send.</p>

    <button type="submit" class="btn btn-success btn-sm mt-3" [disabled]="form.invalid">
      Send email
    </button>
  </form>
</section>
